import { type SkillManifest } from '@brandschutz/shared';
import type { FrontendSkill } from '../_core/registry';
import { NotificationsBell } from './NotificationsBell';

/**
 * Schlanker Skill-Descriptor — wird vom Bootstrap importiert, OHNE den Barrel
 * eager zu laden. `NotificationsBell` steht global in der Topbar und rendert
 * sofort nach Login — lazy würde hier nur ein Aufpoppen erzeugen, daher
 * direkter Import (analog zu `CommandPaletteTrigger`).
 */
const manifest: SkillManifest = {
  key: 'notifications',
  name: 'Benachrichtigungen',
  description:
    'Glocke mit Ungelesen-Zähler und Dropdown-Liste — pollt /notifications/count alle 30s.',
  category: 'collaboration',
  version: '0.1.0',
  enabledByDefault: true,
};

export const notificationsSkill: FrontendSkill = {
  manifest,
  slots: {
    'global.topbar.actions': [
      {
        key: 'notifications-bell',
        order: 20,
        render: NotificationsBell,
      },
    ],
  },
};
